'use client';

import { useEffect } from 'react';
import { ErrorBoundary } from '@benzinga/core-ui';
import { menus, NavigationHeader, NavigationHeaderProps } from '@benzinga/navigation-ui';
import { disableOptinMonsterCampaigns } from '@benzinga/ads-utils';
import { HeaderProps } from '../../../src/entities/header';
import '../../styles/header.scss';

export interface RootHeaderProps {
  headerProps: NavigationHeaderProps & HeaderProps;
}

const RootHeader: React.FC<RootHeaderProps> = ({ headerProps }) => {
  useEffect(() => {
    document.addEventListener('om.Scripts.init', event => {
      if (event && event['detail']) {
        event['detail'].Scripts.enabled.fonts = false;
      }
    });

    disableOptinMonsterCampaigns();
  }, []);

  if (headerProps?.hideNavigationBar) {
    return null;
  }

  return (
    <ErrorBoundary name="header">
      <NavigationHeader
        hideBanner={headerProps?.hideBanner}
        hideQuoteBar={headerProps?.hideQuoteBar}
        initialBreakingsNews={headerProps?.breakingNews}
        logoVariant={headerProps?.navigationLogoVariant || 'default'}
        marketTickers={headerProps?.marketTickers}
        menus={headerProps?.menus ?? menus}
        quotes={headerProps?.quotes}
        showAboveHeaderBlock={false}
        raptiveExpandedHeader={headerProps?.raptiveExpandedHeader}
        showRaptiveBanner={headerProps?.showRaptiveBanner}
        showRotatingBanner={
          typeof headerProps?.showRotatingBanner === 'boolean' ? headerProps?.showRotatingBanner : true
        }
        sticky={headerProps?.sticky}
        variant={headerProps?.variant ?? 'default'}
      />
    </ErrorBoundary>
  );
};

export default RootHeader;
